// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1zVXl","info":"UpdateTermsInfo_info__1vag5"};